import clsx from 'clsx';

export function Toggle({
  checked,
  onChange,
  label,
  disabled,
}: {
  checked: boolean;
  onChange: (next: boolean) => void;
  label: string;
  disabled?: boolean;
}) {
  return (
    <button
      type="button"
      role="switch"
      aria-checked={checked}
      aria-label={label}
      disabled={disabled}
      onClick={() => onChange(!checked)}
      className={clsx(
        'relative inline-flex h-6 w-11 shrink-0 items-center rounded-full transition disabled:opacity-40',
        checked ? 'bg-primary' : 'bg-surface-raised',
      )}
    >
      <span
        className={clsx(
          'inline-block size-4.5 rounded-full transition duration-200',
          checked ? 'translate-x-[23px] bg-on-status' : 'translate-x-[3px] bg-fg-muted',
        )}
      />
    </button>
  );
}
